import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const RepublicSeedrsMonoLogoIcon = (props: IconProps) => (
  <ChakraIcon
    width="352"
    height="61"
    viewBox="0 0 352 61"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="uvhuit_jvoie84"
      width="62"
      height="60"
      x="117"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M178.774.007h-60.776V60h60.776z"
        clipRule="evenodd"
      />
    </mask>
    <g
      fill="#fff"
      fillRule="evenodd"
      clipRule="evenodd"
      mask="url(#uvhuit_jvoie84)"
    >
      <path d="M126.777 22c7.855-7.75 40.246-12.872 42.999-13.296-11.878-11.63-31.062-11.607-42.902.083-10.775 10.636-11.738 27.248-2.959 38.993A20.53 20.53 0 0 1 126.777 22M169.954 8.877c-.429 2.718-5.615 34.695-13.468 42.445-7.098 7.007-18.004 7.936-26.131 2.821 11.901 8.672 28.738 7.724 39.515-2.913a29.733 29.733 0 0 0 .084-42.353" />
    </g>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M157.9 43.815c-6.352 4.2-15.223 3.36-21.071-2.412-5.862-5.784-6.7-14.572-2.409-20.845-3.506 1.368-6.424 2.89-8.102 4.547a18.66 18.66 0 0 0-5.588 13.256c.39 4.726 2.385 9.346 6.047 12.96 3.56 3.515 8.082 5.474 12.728 5.937 4.989.08 10.003-1.747 13.811-5.505 1.669-1.647 3.204-4.504 4.584-7.938M215.726 4.597v6.98q-3.31-2.34-5.956-2.34-2.857.001-4.669 1.996-1.81 1.894-1.81 5.05 0 2.788 1.288 4.78.66 1.064 2.18 2.748 1.51 1.685 3.914 4.058 4.426 4.432 6.024 7.665c1.068 2.086 1.598 4.637 1.598 7.666 0 4.101-1.165 7.483-3.507 10.138q-3.524 3.885-9.021 3.887-4.633 0-7.908-2.514v-7.078q3.865 2.785 7.036 2.785c1.974 0 3.513-.65 4.628-1.941 1.119-1.294 1.676-3.056 1.676-5.277 0-1.923-.432-3.656-1.289-5.19-.446-.734-1.058-1.58-1.852-2.53q-1.182-1.424-2.957-3.178c-1.831-1.787-3.354-3.369-4.559-4.743q-1.813-2.064-2.683-3.611-1.671-3.021-1.671-7.628c0-4.148 1.088-7.438 3.274-9.866 2.207-2.453 5.16-3.678 8.88-3.678 2.575 0 5.039.607 7.384 1.821M222.673 3.496h19.255V9.55h-12.013v16.807h10.655v6.051h-10.655v18.111h12.013v6.048h-19.255zM247.289 3.496h19.258V9.55h-12.016v16.807h10.659v6.051h-10.659v18.111h12.016v6.048h-19.258zM278.502 50.315q6.613 0 8.847-3.955 2.297-3.952 2.298-15.364c0-8.181-.735-13.81-2.193-16.878q-2.195-4.604-8.045-4.604h-.907zm-7.244-46.819h8.916q4.074.001 6.865.895 2.57.858 4.592 3.06c2.021 2.2 3.458 5.065 4.322 8.592q1.285 5.121 1.286 14.679 0 8.767-1.43 14.298c-.925 3.53-2.461 6.221-4.594 8.077q-3.94 3.47-14.102 3.47h-5.855zM310.181 27.01c2.809 0 4.797-.641 5.956-1.925q1.742-1.924 1.742-6.5c0-1.647-.12-3.055-.369-4.229-.242-1.164-.628-2.116-1.147-2.848a4.63 4.63 0 0 0-2.019-1.617q-1.237-.514-2.944-.514h-1.219zm-7.243-23.514h9.542q5.915.001 8.809 2.785 3.66 3.612 3.659 11.033-.001 5.71-1.932 9.163-1.935 3.455-5.519 4.277l9.889 25.812h-7.349l-9.856-25.983v25.983h-7.243zM349.204 4.597v6.98c-2.208-1.559-4.19-2.34-5.955-2.34q-2.856.001-4.669 1.996-1.81 1.894-1.81 5.05 0 2.788 1.289 4.78.66 1.064 2.174 2.748c1.007 1.122 2.32 2.477 3.921 4.058q4.423 4.432 6.024 7.665c1.065 2.086 1.603 4.637 1.603 7.666 0 4.101-1.176 7.483-3.515 10.138q-3.522 3.885-9.025 3.887-4.63 0-7.904-2.514v-7.078q3.87 2.785 7.034 2.785c1.976 0 3.519-.65 4.638-1.941 1.11-1.294 1.666-3.056 1.666-5.277 0-1.923-.431-3.656-1.287-5.19q-.663-1.103-1.846-2.53-1.188-1.424-2.962-3.178-2.75-2.681-4.561-4.743-1.812-2.064-2.682-3.611-1.672-3.021-1.673-7.628c0-4.148 1.094-7.438 3.273-9.866q3.31-3.679 8.884-3.678 3.862 0 7.383 1.821M84.884 60V0h2.07v60zM.044.35l28.098.002c.508 0 2.408.056 3.545.205h.005c8.88 1.134 15.743 8.776 15.743 18.035 0 7.219-4.171 13.459-10.221 16.395l-.355.172.215.336 16.08 25.154H.044zM2.64 2.948v55.107h45.774l-13.528-21.16-1.787-2.796 2.981-1.447a15.6 15.6 0 0 0 8.76-14.06c0-7.951-5.892-14.49-13.476-15.458l-.007-.001h-.006c-.972-.13-2.745-.185-3.21-.185z"
      clipRule="evenodd"
    />
    <path fill="#fff" d="m12.49 2.211 1.464-.938 36.452 56.92-1.465.938z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11.593 2.014 14.151.377l37.152 58.012-2.558 1.638zm1.793.394 35.752 55.826.372-.238L13.758 2.17z"
      clipRule="evenodd"
    />
    <path fill="#fff" d="M2.156 57.471 24.34 22.974l-.302-2.738L.895 56.664z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m24.482 18.33.53 4.801-22.66 35.236L0 56.86zM1.789 56.466l.171.11 21.71-33.76-.074-.673z"
      clipRule="evenodd"
    />
    <path fill="#fff" d="M2.211 34.713h32.552v1.74H2.212z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M1.562 34.064h33.85v3.038H1.562zm1.298 1.298v.442h31.255v-.442z"
      clipRule="evenodd"
    />
    <path fill="#fff" d="M24.184 57.431V21.158h1.74V57.43z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M23.536 58.08V20.509h3.036V58.08zm1.297-1.298h.442V21.807h-.442z"
      clipRule="evenodd"
    />
  </ChakraIcon>
);
